import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";

const posts = [
  { t: "Understanding chronic migraine in classical homeopathy", d: "How constitutional remedies reshape recurring headache patterns.", date: "12 May 2026" },
  { t: "Managing PCOS without hormonal pills", d: "Five things every woman should know about long-term homeopathic care.", date: "02 May 2026" },
  { t: "Paediatric homeopathy: gentle, safe, lasting", d: "Why parents are choosing homeopathy for childhood ailments.", date: "18 Apr 2026" },
];

export default function Blog() {
  return (
    <div>
      <MarketingHeader />
      <section className="max-w-6xl mx-auto px-5 md:px-10 py-16 md:py-24">
        <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[color:var(--muted)] mb-3">Journal</p>
        <h1 className="font-heading text-4xl md:text-6xl font-light tracking-tight mb-12">Notes from the practice.</h1>
        <div className="grid md:grid-cols-3 gap-6">
          {posts.map((p) => (
            <article key={p.t} className="bg-white border border-[color:var(--border)] rounded-2xl p-6 hover:shadow-lg transition-shadow cursor-pointer" data-testid={`blog-post-${p.t.toLowerCase().slice(0,30).replace(/[^a-z]+/g,'-')}`}>
              <p className="text-xs text-[color:var(--muted)] tracking-wider uppercase">{p.date}</p>
              <h2 className="font-heading text-xl text-[color:var(--ink)] font-medium mt-3 leading-snug">{p.t}</h2>
              <p className="text-sm text-[color:var(--muted)] mt-3 leading-relaxed">{p.d}</p>
            </article>
          ))}
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
